module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-43.e21f3b96.png";